module.exports = __webpack_public_path__ + "static/media/24UHCHR15.c426ded1.jpg";